import { render, staticRenderFns } from "./QqGroup.vue?vue&type=template&id=547ecdae&scoped=true&"
import script from "./QqGroup.vue?vue&type=script&lang=js&"
export * from "./QqGroup.vue?vue&type=script&lang=js&"
import style0 from "./QqGroup.vue?vue&type=style&index=0&id=547ecdae&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "547ecdae",
  null
  
)

export default component.exports